import { render, staticRenderFns } from "./AffiliatesCode.vue?vue&type=template&id=b1928396&scoped=true"
import script from "./AffiliatesCode.vue?vue&type=script&lang=js"
export * from "./AffiliatesCode.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesCode.vue?vue&type=style&index=0&id=b1928396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1928396",
  null
  
)

export default component.exports